import styled, { css } from 'styled-components';
import { Typography } from '../../../ui/Typography';

export const CitiesContainer = styled.div<{ $loading: boolean }>`
  padding-bottom: env(safe-area-inset-bottom);

  ${({ $loading }) =>
    $loading &&
    css`
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    `}
`;

export const SectionCitiesTitle = styled(Typography)`
  margin-bottom: 15px;
`;

const labelsStyles = css`
  label {
    padding: 12px 0;
    cursor: pointer;

    &::after {
      display: none;
    }
  }
`;

const tabletCitiesStyles = css`
  margin-bottom: 25px;
  padding-bottom: 10px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0 7px;
`;

const desktopCitiesStyles = css`
  grid-template-columns: repeat(5, 1fr);
  gap: 0 40px;
`;

export const PopularCitiesContainer = styled.div`
  margin-bottom: 15px;
  ${labelsStyles}

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0 20px;

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    ${tabletCitiesStyles}
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    ${desktopCitiesStyles}
  }
`;

export const AllCitiesContainer = styled.div`
  ${labelsStyles}

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    ${tabletCitiesStyles}
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    ${desktopCitiesStyles}
  }
`;
